export const GettingStartedRoute = "GettingStartedRoute";
export const LoginRoute = "LoginRoute";
export const SignupRoute = "SignupRoute";
export const ForgotPasswordRoute = "ForgotPasswordRoute";
export const OrganizationAccessDeniedRoute = "OrganizationAccessDeniedRoute";

export const ChangePasswordRoute = "ChangePassword";